import React, { useEffect, useState } from 'react';
import './App.css';

import { ThemeProvider, createTheme } from '@mui/material/styles';
// MUI GRID
import Box from '@mui/material/Box';
import Grid from '@mui/material/Unstable_Grid2';

import Button from '@mui/material/Button';
// MUI TOGGLE BUTTON
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
// MUI RELATED IMPORTS DATEPICKER
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker, enUS } from '@mui/x-date-pickers';

import { Settings } from 'luxon';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { DateTime } from 'luxon';

// MUI SELECT
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';

import axios from 'axios';

// const theme = createTheme({
//   palette: {
//     // primary: {
//     //   main: red[500],
//     // },
//     mode: 'dark',
//   },
// });

const DEFAULT_NOTE = "What do we need to know about your order? Or feel free to share some random knowledge with us...";

function App() {
  // TODOS
  // NEED TO HANDLE CERTAIN PRODUCTS IN THE CART
  Settings.defaultZone = 'America/New_York';
  // HANDLE CART STATE AND UPDATE PROPERTIES
  const [cart, setCart] = useState([]);
  const [method, setMethod] = useState('DELIVERY');
  const [value, setValue] = useState(null);
  const [settings, setSettings] = useState({});
  const [currentDateTime, setCurrentDateTime] = useState(null);
  const [pickupTimes, setPickupTimes] = useState([]);
  const [timeslot, setTimeslot] = useState('');
  const [orderNote, setOrderNote] = useState(DEFAULT_NOTE);
  const [needsSpecificDates, setNeedsSpecificDates] = useState(false);
  const [specificDates, setSpecificDates] = useState([]);

  const [loading, setLoading] = useState(false);
  const [hasntSelectedDate, setHasntSelectedDate] = useState(true);

  const handleSelectChange = (event) => {
    setTimeslot(event.target.value);
  };

  // END SELECT TIMESLOT

  const handleChange = (event, newMethod) => {
    if (newMethod !== null) {
      setMethod(newMethod);
    }
  };

  const containsAvailableProducts = (cart) => {
    // iterate each available dates setting, see if associated products match any products in the cart
    if (cart && cart.items?.length > 0) {
      if (settings?.availableDates?.length > 0 && method === 'DELIVERY') {
        settings.availableDates.forEach((item) => {
          item.products.forEach((product) => {
            cart.items.forEach((cartItem) => {
              if (
                cartItem.product_id.toString() ===
                product.shopify_id.replace('gid://shopify/Product/', '')
              ) {
                setNeedsSpecificDates(true);
                setSpecificDates((current) => [...current, item]);
              }
            });
          });
        });
      } else {
        // Turns out that curbside has the same restrictions as delivery, so we don't want to unset this.  We actualy want these settings if they switch to curbside as well.
        // setNeedsSpecificDates(false);
        // setSpecificDates([]);
      }
    }
  };

  const checkBlackoutDates = (settingsDates, muiDate) => {
    let isBlackout = false;
    const formatted_settings_dates = settingsDates.map((settingsDate) => {
      return DateTime.fromISO(settingsDate.date, { zone: 'utc' });
    });

    formatted_settings_dates.forEach((formattedSettingsDate) => {
      if (
        muiDate.setZone('America/New_York').toFormat('yyyy-MM-dd') ===
        formattedSettingsDate.setZone('America/New_York').toFormat('yyyy-MM-dd')
      ) {
        isBlackout = true;
      }
    });
    return isBlackout;
  };

  // if the current time in new york is after the cutoff time, then we need to disable the current day
  const isCutoffTime = (date) => {
    if (settings.cutoffTime) {
      const { cutoffTime } = settings;
      const cutoff_time = DateTime.fromISO(cutoffTime).toFormat('HH:mm');
      const now_time = currentDateTime.toFormat('HH:mm');
      const today_date = currentDateTime;

      const day_end_of_cutoff_period = currentDateTime.plus({
        days: settings.daysInAdvanceBeforeCutoffTime,
      });

      // blackout the date if today
      if (
        date.toFormat('yyyy-MM-dd') === currentDateTime.toFormat('yyyy-MM-dd')
      ) {
        return true;
      }

      // if the date being checked is before the date being set for cutoff
      if (date < day_end_of_cutoff_period) {
        // then we need to check the time
        console.log(now_time, cutoff_time, date.toFormat('yyyy-MM-dd'));
        if (now_time > cutoff_time) {
          return true;
        }
      } else {
        // if date is after the cutoff date, then we know it's not blacked out
        return false;
      }
    }
    // return false to not blackout
    return false;
  };

  const isSpecificDate = (date) => {
    // iterate through each item in specific dates, and see if the date is in the array
    // if it is, then we need to disable the date by returning true
    let isSpecific = false;
    specificDates.forEach((specificDate) => {
      console.log(
        date.toFormat('yyyy-MM-dd'),
        DateTime.fromISO(specificDate.date, { zone: 'utc' })
          .setZone('America/New_York')
          .toFormat('yyyy-MM-dd'),
      );
      if (
        date.toFormat('yyyy-MM-dd') ===
        DateTime.fromISO(specificDate.date, { zone: 'utc' })
          .setZone('America/New_York')
          .toFormat('yyyy-MM-dd')
      ) {
        isSpecific = true;
      }
    });
    return isSpecific;
  };

  const isDateAfterNumMonths = (date, numMonths) => {
    const comparisonDate = DateTime.fromISO(date, { zone: 'utc' })
      .setZone('America/New_York')
    const cutoffDate = DateTime.fromISO(DateTime.now(), { zone: 'utc' })
      .setZone('America/New_York')
      .plus({ months: numMonths });

    return comparisonDate > cutoffDate
  }

  const disableDate = (date) => {
    let isBlackoutDate = false;

    if (isDateAfterNumMonths(date, 3)) {
      isBlackoutDate = true;
      return isBlackoutDate;
    }

    if (needsSpecificDates) {
      isBlackoutDate = !isSpecificDate(date);
      if (isBlackoutDate) return isBlackoutDate;
    }

    // check to see if the date is in the blackout dates array
    if (settings.blackoutDates && settings.blackoutDates.length > 0) {
      const { blackoutDates } = settings;

      isBlackoutDate = checkBlackoutDates(blackoutDates, date);
      if (isBlackoutDate) return isBlackoutDate;
    }

    if (method === 'DELIVERY') {
      // check to see if the day of the week is disabled, if so return true
      if (settings.deliveryDays && settings.deliveryDays.length > 0) {
        const { deliveryDays } = settings;
        deliveryDays.forEach((item) => {
          if (date.toFormat('cccc') === item.day && item.available === false) {
            isBlackoutDate = true;
          }
        });
        if (isBlackoutDate) return isBlackoutDate;
      }
    }
    if (method === 'CURBSIDE') {
      if (settings.pickupTimes) {
        const { pickupTimes } = settings;
        pickupTimes.forEach((item) => {
          if (date.toFormat('cccc') === item.day && item.available === false) {
            isBlackoutDate = true;
          }
        });
        if (isBlackoutDate) return isBlackoutDate;
      }
    }

    const isCutoff = isCutoffTime(date);
    if (isCutoff) {
      isBlackoutDate = true;
      if (isBlackoutDate) return isBlackoutDate;
    }
    return false;
  };

  const getPickupTimes = (value) => {
    if (settings.pickupTimes) {
      if (value) {
        const today = value.setZone('America/New_York').toFormat('cccc');
        const { pickupTimes } = settings;
        console.log(pickupTimes);
        const todayTimes = pickupTimes.filter((item) => {
          return item.day === today;
        });
        console.log(todayTimes);
        let { start, end } = todayTimes[0];
        start = DateTime.fromISO(start).setZone('America/New_York');
        console.log('start time', start.toFormat('HH:mm'));
        end = DateTime.fromISO(end).setZone('America/New_York');
        let timeslots = [start];
        while (start.toFormat('hh:mm a') !== end.toFormat('hh:mm a')) {
          const newTime = start.plus({ minutes: 15 });
          timeslots.push(newTime);
          start = newTime;
        }

        const timeslots_formatted = timeslots.map((item) => {
          return item.toFormat('hh:mm a');
        });

        setPickupTimes(timeslots_formatted);
      } else {
        setPickupTimes([]);
      }
    }
  };

  // Updates each line of the cart with the method and value properties
  // run this function whenever the cart, date or method changes

  const getCart = async () => {
    if (window && window.Shopify) {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      console.log('cart', cart);
      setCart(cart);
    }
  };

  const setDate = async () => {
    if (window && window.Shopify && cart && cart.items) {
      try {
        let attributes = {};

        if (method === 'DELIVERY') {
          attributes = {
            'Delivery-Date': value.toFormat('MM-dd-yyyy'),
            'Curbside-Date': '',
            'Pickup-Time': '',
            discount_code: '',
          };
        } else {
          attributes = {
            'Curbside-Date': value.toFormat('MM-dd-yyyy'),
            'Delivery-Date': '',
            'Pickup-Time': timeslot,
          };
        }
        const { data } = await axios.post('/cart/update.js', {
          attributes,
        });
        console.log('attributes_response', data.attributes);
        for (let i = 0; i < cart.items.length; i++) {
          const properties = {
            method: method,
            _date: value,
            date: value.toFormat('MM-dd-yyyy')
          };
          if (timeslot) properties.timeslot = timeslot;

          const response = await axios.post('/cart/change.js', {
            line: i + 1,
            properties: properties,
            quantity: cart.items[i].quantity
          });

          if (response.status === 200) {
            console.log('success adding properties');
            console.log('update cart response', response.data);
          } else {
            console.error('error adding properties');
          }
        }
        setHasntSelectedDate(false);
      } catch (e) {
        console.error(e);
      }
    } else {
      console.error('cart is empty');
    }
  };

  useEffect(() => {
    if (window) {
      getCart();
    }
  }, []);

  useEffect(() => {
    if (cart && method && value) {
      setDate();
    } else {
      console.log('use effect set date called and failed', cart, method, value);
    }
  }, [value, timeslot]);

  useEffect(() => {
    containsAvailableProducts(cart);
  }, [cart, settings]);

  useEffect(() => {
    if (method === 'CURBSIDE') {
      getPickupTimes(value);
    } else {
      setPickupTimes([]);
      setTimeslot('');
    }
  }, [method, value]);

  const showHideDynamicCart = (method) => {
    if (window) {
      const element = window.document.getElementById('dynamic-checkout-cart');
      if (element) {
        console.log(element, method);
        if (method === 'DELIVERY') {
          element.style.display = 'block';
        } else {
          element.style.display = 'none';
        }
      } else {
        console.log('no element');
      }
    } else {
      console.log('no window');
    }
  };

  useEffect(() => {
    async function fetchData(method) {
      let url = 'shipped/settings';
      if (method === 'CURBSIDE') {
        url = 'curbside/settings';
      }
      const response = await fetch(
        'https://cherrystone-backend.conspireagency.com/api/' + url,
      );
      const data = await response.json();
      console.log('settings', data);

      setSettings(data);
      setCurrentDateTime(
        DateTime.fromISO(data.currentTime).setZone('America/New_York'),
      );
      setValue(null);
    }
    fetchData(method);
    showHideDynamicCart(method);
    return () => {};
  }, [method]);

  // attach on to current checkout button and trigger checkout when clicked
  useEffect(() => {
    if (window) {
      document.getElementById('checkout_btn').onclick = (e) => {
        e.preventDefault();
        handleCheckoutButton();
      };
    }
    return () => {
      document.getElementById('checkout_btn').onclick = null;
    };
  }, [hasntSelectedDate, value, method]);

  const handleCheckoutButton = async () => {
    console.log('handle checkout', hasntSelectedDate, cart, method);
    if (window && cart.items.length > 0) {
      let checkout_url = `${window.location.origin}`;
      const checkoutBtn = document.getElementById('checkout_btn');

      if (hasntSelectedDate === false) {
        checkoutBtn.classList.add('is-loading');

        if (orderNote && orderNote !== DEFAULT_NOTE) {
          const response = await axios.post('/cart/update.js', {
            note: orderNote
          });

          if (response.status === 200) {
            console.log('success adding orderNote');
            console.log('update cart response', response.data);
          } else {
            console.error('error adding orderNote');
          }
        }

        if (method === 'CURBSIDE') {
          setLoading(true);
          const { data } = await axios.post(
            'https://cherrystone-backend.conspireagency.com/api/curbside-discount/price-rule',
          );
          checkout_url = checkout_url + '/checkout?discount=' + `${data}`;
          console.log('checkout_url', checkout_url, data);

          window.location.href = encodeURI(checkout_url);
        } else if (method === 'DELIVERY') {
          checkout_url = checkout_url + '/checkout?discount=';

          console.log(checkout_url);
          window.location.href = encodeURI(checkout_url);
        } else {
          checkoutBtn.classList.remove('is-loading');
          console.error('no method selected');
        }
      }
    }
  };

  const onKeyDown = (e) => {
    e.preventDefault();
  };

  return (
    <div className="App">
      <Box sx={{ flexGrow: 1 }}>
        <Grid container>
          <Grid
            xs={12}
            md={4}
            style={{ textAlign: 'left' }}
            display="flex"
            flexDirection="column"
            justifyContent="flex-start"
            alignItems="flex-start"
            className="conspire_note"
          >
            <p className="custom-field-label">Order Note</p>
            <TextField
              hiddenLabel
              id="outlined-multiline-static"
              multiline
              value={orderNote}
              onChange={(e) => {
                setOrderNote(e.target.value)
              }}
              rows={4}
              defaultValue="What do we need to know about your order? Or feel free to share some random knowledge with us..."
              fullWidth
            />
          </Grid>
          <Grid
            xs={12}
            md={4}
            display="flex"
            flexDirection="column"
            justifyContent="flex-start"
            alignItems="center"
            className="conspire_method"
          >
            <p className="custom-field-label">Delivery Methods</p>
            <ToggleButtonGroup
              color="primary"
              value={method}
              exclusive
              onChange={handleChange}
              aria-label="Delivery Method"
              size="large"
              fullWidth
            >
              <ToggleButton value="DELIVERY">Delivery</ToggleButton>
              <ToggleButton value="CURBSIDE">Curbside pick-up</ToggleButton>
            </ToggleButtonGroup>
          </Grid>
          <Grid container xs={12} md={4}>
            <LocalizationProvider
              dateAdapter={AdapterLuxon}
              adapterLocale={'en-US'}
            >
              {currentDateTime &&
                settings &&
                settings.cutoffTime &&
                console.log(
                  'Current 24 hour time AM/NYC',
                  currentDateTime.toFormat('HH mm'),
                  'Cutoff time',
                  DateTime.fromISO(settings.cutoffTime).toFormat('HH mm'),
                )}
              <Grid
                xs={12}
                md={12}
                display="flex"
                flexDirection="column"
                justifyContent="flex-start"
                alignItems="flex-start"
                style={{ marginBottom: '10px' }}
                className="conspire_date"
              >
                <p className="custom-field-label">Delivery Date</p>
                <DatePicker
                  renderInput={(params) => (
                    <TextField fullWidth onKeyDown={onKeyDown} {...params} />
                  )}
                  inputFormat="yyyy-MM-dd"
                  label="Select Date"
                  value={value}
                  disablePast={true}
                  onChange={(newValue) => {
                    setValue(newValue);
                  }}
                  shouldDisableDate={disableDate}
                />
              </Grid>
              <Grid
                xs={12}
                md={12}
                display="flex"
                justifyContent="flex-start"
                alignItems="flex-start"
                style={{ marginBottom: '10px', textAlign: 'left' }}
                className="conspire_cart_text"
              >
                {method === 'DELIVERY' ? (
                  <p>Note: {settings.cartText}</p>
                ) : (
                  <p>
                    Note: To receive Curbside discount, do not use ShopPay or
                    GooglePay at checkout.
                  </p>
                )}
              </Grid>
              {hasntSelectedDate ? (
                <Grid
                  xs={12}
                  md={12}
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="flex-start"
                  className="conspire_warning"
                >
                  <p style={{ color: 'red' }}>
                    Please select delivery date
                  </p>
                </Grid>
              ) : null}

              {needsSpecificDates && specificDates && (
                <Grid
                  xs={12}
                  md={12}
                  display="flex"
                  justifyContent="flex-start"
                  alignItems="flex-start"
                  className="conspire_warning"
                >
                  <p style={{ textAlign: 'right' }}>
                    An item in the cart requires a specific delivery date.
                  </p>
                </Grid>
              )}

              {method === 'CURBSIDE' && pickupTimes.length > 0 && (
                <Grid
                  xs={12}
                  md={12}
                  display="flex"
                  flexDirection="column"
                  justifyContent="flex-start"
                  alignItems="flex-start"
                  className="conspire_timeslot"
                >
                  <p className="custom-field-label">Time Slot</p>
                  <FormControl
                    fullWidth
                    className="conspire_timeslot_control"
                    sx={{ width: '100%' }}
                  >
                    <InputLabel id="demo-simple-select-label">
                      Timeslot
                    </InputLabel>
                    <Select
                      id="demo-simple-select"
                      value={timeslot}
                      label="Timeslot"
                      onChange={handleSelectChange}
                      sx={{ width: '100%' }}
                    >
                      {pickupTimes &&
                        pickupTimes.map((item, i) => {
                          return (
                            <MenuItem key={i} value={item}>
                              {item}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </FormControl>
                </Grid>
              )}
            </LocalizationProvider>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default App;
